module.exports = __webpack_public_path__ + "img/FE_A4_front_en.e4525815.png";